<template>
    <v-flex>
        <loading-progress-bar :loading="loading" color="secondary"></loading-progress-bar>
        <vue-plotly v-if="!loading&&data" show-export :data="data" :disable-responsive="disableResponsive" :white-mode="whiteMode" :layout="layout" :options="options" @click="handleClick" ref="plotly"/>
    </v-flex>
</template>

<script>
import VuePlotly from './VuePlotly'
import {callAPI} from '@/helper'
import moment from 'moment'
import LoadingProgressBar from './LoadingProgressBar'

export default {
  props: {
    title: {type: String, default: ''},
    issue: {type: String, default: ''},
    color: {type: String, default: 'rgb(214, 39, 40)'},
      faultDesc: {type: String, default: ''},
    relevantVariables: {type: String, default: ''},
    dateRange: {type: Object, default: null},
    equipmentNames: {type: Array, default: null},
    disableResponsive:{type:Boolean,default:false},
      whiteMode: {type: Boolean, default: false},
  },
  components: {
    VuePlotly,
      LoadingProgressBar
  },

  name: 'FaultComparisonPlot',
  watch: {
    dateRange () {
      this.refresh()
    },
     issue () {
      this.refresh()
    },
    equipmentNames() {
          this.refresh()
    },

  },
  data: function () {
    return {
      data:null,
      layout:null,
      timeout:null,
      facility_name:null,
      options: {},
      df: null,
      loading: true
    }
    },
    mounted(){
      this.refresh()
    },
  methods: {
      handleClick(data){
          this.$router.push({
              path: '/fault-analysis',
              query: {
                  relevantVariables: this.relevantVariables,
                  faultName: this.issue,
                  faultDesc: this.faultDesc,
                  rangeStart: this.dateRange.start,
                  rangeEnd: this.dateRange.end,
                  equipmentName: data.points[0].y
              }
          })
      },
      debounce(callback, wait) {
          clearTimeout(this.timeout);
          this.timeout= setTimeout(() => callback(), wait);
      },
      refresh(){
          this.debounce(this.doRefresh,200);
      },
      getIdForName(name){
          for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
              let otherEquip=this.$store.state.pointsListStore.pointsList.equipment_details[i]
              if (otherEquip.equipment_name===name){
                  return otherEquip.equipment_id
              }
          }
          return null
      },
      doRefresh() {
          this.loading=true;
          this.data=null
          let me=this
          callAPI('issue/',
              {
                  'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                  'issue': this.issue,
                  'equipment_name': this.equipmentNames,
                  'date_range': [this.dateRange.start,this.dateRange.end]
              }
          ).then(function (otherRes)
          {
              let df=otherRes.data
              if(!otherRes.data.equipment_id||otherRes.data.equipment_id.length==0){
                  me.loading=false
                  return
              }
              let timeAxis=[];
              let ts=moment(me.dateRange.start).format('YYYY-MM-DD HH:mm:ss')
              let end=moment(me.dateRange.end).format('YYYY-MM-DD HH:mm:ss')
              while (ts<=end){
                  timeAxis.push(ts)
                  ts=moment(ts).add(me.$store.getters.minutesBetweenSamples,'minutes').format('YYYY-MM-DD HH:mm:ss')
              }
              let refinedDf={
                  x:timeAxis,
                  y:me.equipmentNames,
                  z:[]
              }
              let yids=me.equipmentNames.map(x=>me.getIdForName(x))
              for (let eid of yids){
                  let newZ=new Array(timeAxis.length).fill(0);
                  for (let index in df['equipment_id']){
                      if(df['equipment_id'][index]===eid){
                          newZ[timeAxis.indexOf(df['timestamp'][index])]=1;
                      }
                  }
                  refinedDf.z.push(newZ)
              }
              if(!refinedDf.z[0]){
                  refinedDf.z[0]=new Array(timeAxis.length).fill(0)
              }
              me.data = [{
                  x: refinedDf.x,
                  y: refinedDf.y,
                  z: refinedDf.z,
                  type: 'heatmap',
                  showscale: false,
                  colorscale: [
                      [0, 'rgb(31, 119, 180)'],
                      [1, me.color]
                  ]

              }]
              me.layout={
                  title:me.title,
                  height:Math.max(260,25*me.equipmentNames.length),
                  yaxis: {
                      title: 'Equipment',
                      fixedrange: true,
                      type: 'category',
                      categoryorder: 'array',
                      categoryarray: me.equipmentNames,
                      showticklabels: true,
                      range: me.equipmentNames
                  },
                  xaxis: {
                      title: 'Time ',
                  },
                  margin:{
                      l:300,
                      t:20
                  },
                  hoverlabel: { bgcolor: "#606060" },
              }
              me.loading=false
          })
      }
  }

}

</script>

<style scoped>

</style>
